<template>
  <!-- 下载 -->
  <div class="">
    <v-dialog
    name="basic-t"
    v-model="isShow"
    :title="dialogTitle"
    :close-on-click-modal="closeOnClickModal1"
    :modal="true"
    :width="560"
    :height="204"
    @confirm="handleConfirm"
    @after-close="handleAfterClose"
    v-bind:confirmButtonText= "suredown"
    append-to-body
  >
  确定要开始下载配置文件吗？
  </v-dialog>
    </div>
</template>

<script>
import { downloadUrlFile } from '@/common/libs/utils';
export default {
  components: {},
  props:{
    showInputDialog:{
      type:Boolean,
      default: false
    },

    file_url:{
      type:String,
      default:""
    }
  },
  data() {
    return {
        dialogTitle: "下载",
        closeOnClickModal1: false, //点击周围关闭弹窗
        suredown:"下载",
        filename_all:'',
        isShow:false
    };
  },
  watch:{
    showInputDialog(newVal){
      this.isShow = newVal
    }
  },
  methods: {
    handleConfirm() {
      if(!this.file_url){
        this.$message.error('无下载文件！')
        this.$emit('update:showInputDialog',false)
      }else{
				downloadUrlFile(this.file_url);
      }
    },
    handleAfterClose() {
      this.$emit('update:showInputDialog',false)

    },
  },
  beforeDestroy() {},
};
</script>

<style lang="scss">

</style>
